import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/jobDashboard/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record) {
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM);
  return newRecord;
}
